var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "reconciliation-step-template",
    {
      attrs: {
        nextStep: _vm.nextStep,
        previousStep: _vm.previousStep,
        loading: _vm.loading
      },
      on: {
        next: _vm.goToNextStep,
        previous: function($event) {
          return _vm.$emit("previous")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "content" },
        [
          _c(
            "el-form",
            {
              ref: "step3Form",
              attrs: {
                "label-position": "top",
                model: _vm.formStep,
                "inline-message": true,
                "label-width": "120px"
              }
            },
            [
              _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
                _vm._v(
                  "1 - " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Définissez la colonne de date de transaction"
                      )
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "",
                    prop: "dateColumn",
                    error: _vm.errors.get("dateColumn")
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      staticClass: "step-container-table border-black"
                    },
                    [
                      _c("table-selectable-columns", {
                        attrs: { lines: _vm.csv, max: 1 },
                        model: {
                          value: _vm.value.template.date.columns,
                          callback: function($$v) {
                            _vm.$set(_vm.value.template.date, "columns", $$v)
                          },
                          expression: "value.template.date.columns"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "fs-3 semibold mt-4 mb-2" }, [
                _vm._v(
                  "2 - " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Définissez le format de la date de transaction"
                      )
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "",
                    prop: "dateFormat",
                    error: _vm.errors.get("dateFormat")
                  }
                },
                [
                  _c("select-input", {
                    attrs: { mode: "edit", options: _vm.dateFormats },
                    model: {
                      value: _vm.value.template.date.arguments.format,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.value.template.date.arguments,
                          "format",
                          $$v
                        )
                      },
                      expression: "value.template.date.arguments.format"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }